import { render, staticRenderFns } from "./NewsEdit.vue?vue&type=template&id=14969592&scoped=true"
import script from "./NewsEdit.vue?vue&type=script&lang=ts"
export * from "./NewsEdit.vue?vue&type=script&lang=ts"
import style0 from "./NewsEdit.vue?vue&type=style&index=0&id=14969592&prod&lang=scss&scoped=true"
import style1 from "./NewsEdit.vue?vue&type=style&index=1&id=14969592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14969592",
  null
  
)

export default component.exports